import { render, staticRenderFns } from "./LittleEllipsis.vue?vue&type=template&id=2d379897&"
import script from "./LittleEllipsis.vue?vue&type=script&lang=ts&"
export * from "./LittleEllipsis.vue?vue&type=script&lang=ts&"
import style0 from "./LittleEllipsis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports